import redirectInterceptor from "@/interceptors/redirect_interceptor";
import router from "@/router";
import { getConfig } from "@/config";

const getDefaultState = () => {
  return {
    voyageWindData: null,
    fetchLoading: true,
    fetchError: null
  };
};

const state = getDefaultState();

const getters = {
  chartOptions: (state) => {
    return {
      chart: {
        polar: true,
        type: "column",
        title: {
          text: "",
        },
      },
      title: {
        text: null,
      },
      tooltip: {
        distance: 5,
        valueSuffix: " %",
        valueDecimals: 1,
      },
      legend: {
        align: "center",
        verticalAlign: "bottom",
        layout: "horizontal",
        width: "100%",
        itemStyle: {
          fontSize: "10px"
        },
        labelFormatter: function () {
          const total = this.yData.reduce(
            (accumulator, currentValue) => accumulator + currentValue
          );
          return this.name + " (" + total.toFixed(1) + " % )";
        },
      },
      xAxis: {
        categories: [
          "AHEAD",
          "22.5",
          "45",
          "67.5",
          "ABEAM",
          "112.5",
          "135",
          "157.5",
          "ASTERN",
          "202.5",
          "225",
          "247.5",
          "270",
          "292.5",
          "315",
          "337.5",
        ],
        tickmarkPlacement: "on",
      },
      yAxis: {
        min: 0,
        endOnTick: false,
        showLastLabel: true,
        labels: {
          formatter: function () {
            return this.value;
          },
        },
        reversedStacks: false,
      },
      plotOptions: {
        series: {
          stacking: "normal",
          shadow: false,
          groupPadding: 0,
          pointPlacement: "on",
        },
      },
      credits: {
        enabled: false,
      },
      series: state.voyageWindData === null
        ? []
        : state.voyageWindData,
    };
  }
};

const actions = {
  async fetchVoyageWindData({ commit }, data) {
    commit("SET_FETCH_WIND_DATA_LOADING_STATE");
    const baseUrl = getConfig().VUE_APP_BASIC_URL;
    const url = `${baseUrl}/vesselInformation/${data.name}/voyageRelativeWindData`;

    const response = await redirectInterceptor.get(url, {
      params: {
        startDate: data.startDate,
        stopDate: data.stopDate
      },
      headers: {
        Authorization: localStorage.getItem("quad_token")
      }
    });
    if (response.status === 200) {
      commit("SET_FETCH_WIND_DATA_SUCCESS_STATE", response.data);
    } else {
      if (response.data.msg === "rdr") {
        router.push("/login");
      }
      commit("SET_FETCH_WIND_DATA_ERROR_STATE");
    }
  },
};

const mutations = {
  SET_FETCH_WIND_DATA_SUCCESS_STATE(state, data) {
    state.voyageWindData = data;
    state.fetchLoading = false;
    state.fetchError = null;
  },
  SET_FETCH_WIND_DATA_LOADING_STATE(state) {
    state.fetchLoading = true;
    state.fetchError = null;
  },
  SET_FETCH_WIND_DATA_ERROR_STATE(state) {
    state.fetchLoading = false;
    state.fetchError = "Could not fetch wind data";
  },
};

export const voyageWindDataModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
